export enum FlipcardSide {
  FRONT = 'front',
  BACK = 'back'
}
